// Product and licence-type definitions shared by the whole portal.
// functions/index.js keeps its own copy of PRODUCTS / ISSUABLE_TYPES — keep
// the two in sync.

export const PRODUCTS = [
  {
    id: "licensekeys", // Firestore collection (name kept: devices use it)
    path: "controller", // URL segment
    name: "LiFE Controller",
    description: "Home Automation Controller",
  },
  {
    id: "joylicenses",
    path: "joy",
    name: "LiFE Joy",
    description: "ESP32 Lighting Controller",
  },
];

export const LICENSE_TYPES = ["Trial", "Annual", "Lifetime"];

// Types that can be generated or allocated as quota. Lifetime keys exist in
// the data but are not offered for new keys (matches the old portal).
export const ISSUABLE_TYPES = ["Trial", "Annual"];

export const productById = (id) => PRODUCTS.find((p) => p.id === id);
export const productByPath = (path) => PRODUCTS.find((p) => p.path === path);
export const productName = (id) => productById(id)?.name || id;

// Quota is tracked per distributor, per product and licence type, in
// distributors/{id}.quota[`${productId}_${type}`] = { allocated, issued }.
export const quotaBucket = (productId, type) => `${productId}_${type}`;
